export default "__VITE_ASSET__a8e9e8c8__"